type FrontendRoute = { name: string };

let frontendRoutes: FrontendRoute[] | undefined;

export const setFrontendRoutes = (routes: FrontendRoute[]) =>
  (frontendRoutes = routes);

export const getFrontendRoutes = () => frontendRoutes;
